import { Flex, Text } from '@shared/components';

export interface RecurringExamEventInfoDetailsSectionProps {
  registrationRange: string;
  dateRange: string;
  location: string;
  buildings: string[];
  province: string;
  proctor: string;
  examStartTime: string;
  examEndTime: string;
}
export default function RecurringExamEventInfoDetailsSection(
  props: Readonly<RecurringExamEventInfoDetailsSectionProps>,
) {
  const {
    registrationRange,
    dateRange,
    location,
    buildings,
    province,
    proctor,
    examStartTime,
    examEndTime,
  } = props;
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: (theme) => theme.spacing(2),
        padding: (theme) => theme.spacing(4),
      }}
    >
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Text sx={{ minWidth: '140px' }}>ช่วงวันที่สอบ:</Text>
        <Text variant='body1Semibold'>{registrationRange}</Text>
      </Flex>
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Text sx={{ minWidth: '140px' }}>วันสอบ:</Text>
        <Text variant='body1Semibold'>{dateRange}</Text>
      </Flex>
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Text sx={{ minWidth: '140px' }}>สถานที่สอบ:</Text>
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
          <Text variant='body1Semibold'>{location}</Text>
          {buildings.map((buildingName) => (
            <Text key={buildingName} variant='body2'>
              {buildingName}
            </Text>
          ))}
        </Flex>
      </Flex>
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Text sx={{ minWidth: '140px' }}>จังหวัด:</Text>
        <Text variant='body1Semibold'>{province}</Text>
      </Flex>
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Text sx={{ minWidth: '140px' }}>ผู้คุมสอบ:</Text>
        <Text variant='body1Semibold'>{proctor}</Text>
      </Flex>
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <Text sx={{ minWidth: '140px' }}>วันที่เปิด-ปิดรับสมัคร:</Text>
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
          <Text variant='body1Semibold'>{examStartTime}</Text>
          <Text variant='body1Semibold'>{examEndTime}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
